import React, { useCallback, useState } from 'react';

import { App, Spin, Typography } from 'antd';

import ActionCollapse from 'v2/components/Shared/QuickView/ActionCollapse';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingProductService from 'v2/services/shopping/product';

import { Icon } from '@eduzz/ui-antd-theme';

const ProducerContact = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const { message } = App.useApp();
  const [loadingProducerData, setLoadingProducerData] = useState<boolean>(false);
  const [producerData, setProducerData] = React.useState<ShoppingDelivery | null>(null);

  const handleClickProducerData = useCallback(
    async (invoiceId: string) => {
      setLoadingProducerData(true);
      shoppingProductService.producerContact(invoiceId).subscribe(
        res => {
          setProducerData(res.data);
          setLoadingProducerData(false);
        },
        () => {
          setLoadingProducerData(false);
          message.error('Não foi possível carregar os dados do produtor.');
        }
      );
    },
    [message]
  );

  return (
    <ActionCollapse
      title='Contato com Produtor'
      icon={<Icon.User size={16} />}
      onExpand={expanded => {
        if (expanded) {
          handleClickProducerData(delivery.invoice_id.toString());
        }
      }}
    >
      {loadingProducerData && <Spin />}

      {producerData && !loadingProducerData && (
        <div className='flex flex-col gap-1'>
          {producerData.producer.name && (
            <div className='text-sm'>
              <Typography.Text>Nome: </Typography.Text>
              <Typography.Text type='secondary'>{producerData.producer.name}</Typography.Text>
            </div>
          )}
          {producerData.producer.email && (
            <div className='text-sm'>
              <Typography.Text>E-mail: </Typography.Text>
              <Typography.Text type='secondary'>{producerData.producer.email}</Typography.Text>
            </div>
          )}
          {producerData.producer.phone && (
            <div className='text-sm'>
              <Typography.Text>Telefone: </Typography.Text>
              <Typography.Text type='secondary'>{producerData.producer.phone}</Typography.Text>
            </div>
          )}
          {producerData.producer.address && (
            <div className='text-sm'>
              <Typography.Text>Endereço: </Typography.Text>
              <Typography.Text type='secondary'>{producerData.producer.address}</Typography.Text>
            </div>
          )}
        </div>
      )}
    </ActionCollapse>
  );
};

export default ProducerContact;
